import React, { useEffect, useReducer, useState } from "react";
import "./profileForm.css";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  retrieveTitle,
  retrieveGender,
  retrieveChargingSites,
  retrieveCity,
  retrieveCountry,
  retrieveState,
  retrieveAddressType,
  retrieveStateByCountryId,
  retrieveCitiesByCountryId,
  apiEndpointFailed,
} from "../../actions/commonActions";
import { logout } from "../../utils/helper";
function reducer(state, { field, value, type }) {
  if (type == "UPDATE_ALL") return value;
  return {
    ...state,
    [field]: value,
  };
}
function ProfileForm({ onSubmit, initialState, isEditProfile }) {
  const dispatch = useDispatch();
  const history = useHistory();

  // use reducer to to trigger onChange on every field change
  const [state, setState] = useReducer(reducer, initialState);
  const [showAddressFields, setShowAddressFields] = useState(false);
  const [modalStatus, setModalStatus] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showconfirmPassword, setShowConfirmPassword] = useState(false);

  const [confirmPassword, setConfirmPassword] = useState();

  // Read from redux state
  const {
    genderList,
    titleList,
    chargingSites,
    cityList,
    stateList,
    countryList,
    addressTypes,
    apiEndPointFailed,
  } = useSelector((reduxState) => reduxState.common);
  const { driverProfile } = useSelector((reduxState) => reduxState);

  useEffect(() => {
    retrieveTitle(dispatch);
    retrieveGender(dispatch);
    retrieveChargingSites(dispatch);
    retrieveCountry(dispatch);
    retrieveAddressType(dispatch);
    setModalStatus(driverProfile.creationFailed.error);
  }, []);

  useEffect(() => {
    // if (stateList.length == 0) {
    //   setState({ value: "", field: "state_id" });
    //   setState({ value: "", field: "city_id" });
    // }

    if (cityList.length == 0) {
      setState({ value: "", field: "city_id" });
    }
  }, [stateList, cityList]);

  useEffect(() => {
    setState({ value: initialState, type: "UPDATE_ALL" });
  }, [initialState]);

  useEffect(() => {
    if (state.country_id && state.country_id > 0) {
      retrieveCitiesByCountryId(dispatch, state.country_id);
    }
  }, [state.country_id]);

  // useEffect(() => {
  //   if (state.state_id) {
  //     retrieveCititesByStateId(dispatch, state.state_id);
  //   }
  // }, [state.state_id]);

  useEffect(() => {
    if (driverProfile.id) {
      localStorage.setItem("driverToken", driverProfile.token);
      localStorage.setItem("driver_id", driverProfile.id);
      const first_name = driverProfile.userAccount.person.first_name;
      const last_name = driverProfile.userAccount.person.last_name;
      localStorage.setItem("first_name", first_name);
      localStorage.setItem("last_name", last_name);
      // localStorage.setItem(
      //   "ev_charging_site_id",
      //   driverProfile.evChargingSites.ev_charging_site_id
      // );
      localStorage.setItem("ev_charging_site_id", -1);
      // *********************  Mobile app stuff ***********************
      if (window.webkit) {
        window.webkit.messageHandlers.setToken.postMessage({
          token: driverProfile.token,
          profile_id: `${driverProfile.id}`,
        });
      }
      if (window.androidObj == undefined) {
        window.androidObj = function AndroidClass() {};
      }

      if (window.androidObj.setToken !== undefined) {
        window.androidObj.setToken(
          driverProfile.token,
          driverProfile.id,
          first_name + " " + last_name
        );
      }
      // *********************  Mobile app stuff ***********************
    }
    if (driverProfile.id) {
      history.push(`/profile/${driverProfile.id}`);
    }

    const { personAddress = {} } = driverProfile.userAccount.person;
    if (personAddress.person_address_id) {
      setShowAddressFields(true);
    }
  }, [driverProfile]);

  useEffect(() => {
    setModalStatus(driverProfile.creationFailed.error);
    window.scrollTo(0, 0);
  }, [driverProfile.creationFailed]);

  // if user wants to add address than show default values
  useEffect(() => {
    if (
      showAddressFields &&
      addressTypes.length > 0 &&
      !state.address_type_code
    ) {
      setState({
        field: "address_type_code",
        value: addressTypes[0]["address_type_code"],
      });
    }
  }, [showAddressFields, addressTypes.length, showAddressFields]);

  const onChange = (e) => {
    setState({ field: e.target.name, value: e.target.value });
  };
  const onChangeConfirmPassword = (e) => {
    if (state.password?.includes(e.target.value)) {
      // console.log("targetValue",e.target.value,state)
      setConfirmPassword(false);
    } else {
      setConfirmPassword(true);
    }
  };
  const addressHandler = () => {
    setShowAddressFields(!showAddressFields);
  };

  const exitButtonHandler = () => {
    history.push("/");
    logout();
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const {
      title_code,
      first_name,
      last_name,
      // date_of_birth,
      mobile_phone_number,
      email,
      password,
      sex_code,
      referring_ev_charging_site_id,
      street_line_1,
      street_line_2,
      state_id,
      city_id,
      country_id,
      zip_code,
      address_type_code,
    } = state;
    const payload = {
      driver_category_code: "R",
      referring_ev_charging_site_id,
      driver_id: null,
      discount_code: "JULY_TWENTY_TWENTY",
      user_account_id: null,
      referring_person_id: null,
      last_updated_by: null,
      last_updated_at: null,

      driverCategoryRef: {},
      userAccount: {
        user_role_code: "DR", // Always DR since it is a driver profile
        user_name: email,
        mobile_phone_number: mobile_phone_number,
        email_address: email,
        password: password,
        person: {
          sex_code: 1,
          first_name,
          last_name,
          title_code: 1,
          // date_of_birth,
          personAddress: {
            address_type_code,
            address: {
              street_line_1,
              street_line_2,
              state_id: null,
              city_id,
              country_id: country_id || -1,
              zip_code,
            },
          },
        },
        userRoleRef: {
          user_role_code: "DR",
          name: "Driver",
          creation_date_time: "2020-07-201",
          permission: "?????",
          ev_charging_site_staff_flag: null,
          ev_charging_site_group_staff_flag: null,
          // last_updated_by: null,
          // last_updated_at: null,
        },
      },
    };
    if (country_id < 1) {
      payload.userAccount.person.personAddress = {};
    }
    onSubmit(dispatch, payload);
  };

  const {
    title_code,
    first_name,
    last_name,
    // date_of_birth,
    mobile_phone_number,
    email,
    password,
    sex_code,
    street_line_1,
    street_line_2,
    zip_code,
    state_id,
    city_id,
    country_id,
    address_type_code,
    referring_ev_charging_site_id,
  } = state;

  return (
    <div className="container parentDiv">
      {modalStatus && (
        <div className="alert alert-warning mt-3" role="alert">
          {driverProfile.creationFailed.message}
        </div>
      )}
      <form onSubmit={handleSubmit}>
        {/* <h4 className="py-2">
          <a href="/">
            <i className="fa fa-arrow-left mr-3" aria-hidden="true"></i>
          </a>
          Profile
        </h4> */}
        <div className="form-group mx-from mt-2">
          <input
            className="form-control color mt-2 "
            name="first_name"
            value={first_name}
            onChange={onChange}
            placeholder="First Name"
          />
          <input
            className="form-control color mt-2"
            name="last_name"
            value={last_name}
            onChange={onChange}
            placeholder="Last Name"
          />
          {/* <input
            type="date"
            className="form-control color mt-2"
            placeholder="DOB"
            name="date_of_birth"
            value={date_of_birth}
            onChange={onChange}
          /> */}
          <input
            className="form-control color mt-2"
            placeholder="Mobile Phone"
            name="mobile_phone_number"
            value={mobile_phone_number}
            onChange={onChange}
          />
          <input
            className="form-control color mt-2"
            placeholder="Email"
            type="email"
            name="email"
            value={email}
            onChange={onChange}
          />
          <div style={{ position: "relative" }}>
            <input
              className="form-control color mt-2 col-12"
              style={{ border: confirmPassword && "1px solid red" }}
              placeholder="Password"
              type={showPassword ? "text" : "password"}
              name="password"
              value={password}
              onChange={onChange}
              autoComplete="new-password"
            />
            <i
              className="fa fa-eye float-right"
              style={{
                lineHeight: 2,
                fontSize: "25px",
                zIndex: 900,
                position: "absolute",
                top: "-6px",
                right: "12px",
              }}
              onClick={() => {
                setShowPassword(!showPassword);
              }}
            ></i>
          </div>
          <div style={{ position: "relative" }}>

          <input
            style={{ border: confirmPassword && "1px solid red" }}
            className="form-control color mt-2 col-12"
            placeholder="Confirm Password"
            type={showconfirmPassword ? "text" : "password"}
            name="confirmpassword"
            //value={password}
            onChange={onChangeConfirmPassword}
            autoComplete="new-password"
          />
           <i
              className="fa fa-eye float-right"
              style={{
                lineHeight: 2,
                fontSize: "25px",
                zIndex: 900,
                position: "absolute",
                top: "-6px",
                right: "12px",
              }}
              onClick={() => {
                setShowConfirmPassword(!showconfirmPassword);
              }}
            ></i>
          </div>
        </div>

        {/* <div className="form-group mx-from">
          {showAddressFields ? (
            <div>
              {" "}
              <label className=" mx-2">Address:</label>
              <br />
              <div className="form-group mt-2 d-flex">
                <select
                  className="form-control color mr-2 "
                  name="country_id"
                  value={country_id}
                  onChange={onChange}
                  id="country"
                  required
                >
                  <option value="" disabled>
                    Country
                  </option>
                  {countryList.map((country, index) => (
                    <option key={index} value={country.country_id}>
                      {country.name}
                    </option>
                  ))}
                </select>
                <select
                  className="form-control color "
                  name="city_id"
                  value={city_id}
                  onChange={onChange}
                  id="city"
                  // disabled={stateList.length == 0 || cityList.length == 0}
                  disabled={cityList.length == 0}
                >
                  <option value="" disabled>
                    City
                  </option>
                  {cityList.map((city, index) => (
                    <option key={index} value={city.city_id}>
                      {city.name}
                    </option>
                  ))}
                </select>
              </div>
              <input
                className="form-control color"
                placeholder="street 1"
                type="text"
                name="street_line_1"
                value={street_line_1}
                onChange={onChange}
              />
              <input
                className="form-control color mt-2"
                placeholder="street 2"
                type="text"
                name="street_line_2"
                value={street_line_2}
                onChange={onChange}
              />
              <div className="form-group mt-2 d-flex">
                <select
                  className="form-control color mr-2 "
                  name="address_type_code"
                  value={address_type_code}
                  onChange={onChange}
                  id="addressType"
                  required={address_type_code.length}
                >
                  <option value="" disabled>
                    Address Type
                  </option>
                  {addressTypes.map((addressType, index) => (
                    <option key={index} value={addressType.address_type_code}>
                      {addressType.name}
                    </option>
                  ))}
                </select>
                <input
                  className="form-control color  "
                  placeholder="Zip Code"
                  type="text"
                  name="zip_code"
                  value={zip_code}
                  onChange={onChange}
                />
              </div>
              <button className="btn btn-success btn-sm ml-5 col-2 d-none">
                Add
              </button>
            </div>
          ) : (
            <button
              className="btn btn-info blue-one-bg btn-block"
              onClick={addressHandler}
            >
              Add Address (optional)
            </button>
          )}
        </div> */}

        <button className="btn btn-success btn-sm ml-5 col-2 d-none">
          Add
        </button>
        <div className="form-group mx-from">
          <label className=" mx-2">Station Code</label>
          <br />
          <select
            className="form-control color"
            name="referring_ev_charging_site_id"
            value={referring_ev_charging_site_id}
            onChange={onChange}
            id="site"
            required
          >
            <option value="" disabled>
              Charging Site
            </option>
            {chargingSites
              .filter((s) => !s.template_flag)
              .map((site, index) => (
                <option key={index} value={site.ev_charging_site_id}>
                  {site.name}
                </option>
              ))}
          </select>
          {/* <input
            className="form-control color mt-2"
            type="email"
            placeholder="@email"
          /> */}
          <br />
        </div>
        <div className="row justify-content-center">
          {!isEditProfile && (
            <button
              className="btn btn-default col-5 mr-2"
              onClick={exitButtonHandler}
            >
              Exit
            </button>
          )}
          <button
            disabled={confirmPassword ? true : false}
            type="Submit"
            className=" btn_white_cap btn btn-primary col-5 green-two-bg"
          >
            Submit
          </button>
        </div>
      </form>
    </div>
  );
}

export default ProfileForm;
